import { memo, useCallback, useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { useNavigation, StackNavigationProp } from '@bonanza-social/navigation';
import { Trans } from '@bonanza-social/i18n';
import { Box, Text, Button } from '@bonanza-social/moonlight';
import {
  selectCommunityJackpotEvents,
  selectCommunityJackpotRewards,
} from '../../../state';
import { isEventCompleted } from '../JackpotProgress/JackpotProgress.utils';
import { formatJackpotEndDate } from '../CommunityJackpot.utils';
import { CommunityJackpotNavigatorParamsList } from '../../../navigators/CommunityJackpotNavigator.types';

function JackpotFooter() {
  const navigation =
    useNavigation<StackNavigationProp<CommunityJackpotNavigatorParamsList>>();
  const rewards = useSelector(selectCommunityJackpotRewards);
  const [event] = useSelector(selectCommunityJackpotEvents);
  const eventCompleted = isEventCompleted(event);
  const transValues = useMemo(
    () => ({ endDate: formatJackpotEndDate(event) }),
    [event],
  );
  const transComponents = useMemo(
    () => ({
      endDate: <Text variant="caption-semi" color="darkSurfacePrimary" />,
    }),
    [],
  );

  const onClaimRewards = useCallback(() => {
    navigation.navigate('CommunityJackpotClaimScreen');
  }, [navigation]);

  return (
    <Box padding="space-400" paddingBottom="space-0">
      {!eventCompleted && (
        <Text
          variant="caption"
          locKey="jackpotDuration"
          locNS="communityJackpot"
          color="darkSurfaceMuted"
          paddingBottom="space-400"
          textAlign="center"
        >
          <Trans
            ns="communityJackpot"
            i18nKey="jackpotDuration"
            components={transComponents}
            values={transValues}
          />
        </Text>
      )}
      {rewards.length > 0 ? (
        <Button
          locKey="claimRewards"
          locNS="communityJackpot"
          size="large"
          onPress={onClaimRewards}
        />
      ) : (
        <Button
          variant="secondary"
          locKey="close"
          locNS="common"
          size="large"
          onPress={navigation.goBack}
        />
      )}
    </Box>
  );
}

export default memo(JackpotFooter);
